import { PmiButton } from 'shell/components/shared/button';
import { useFormikContext } from 'formik';
import { emptyIdentityCard } from 'front-office/utils/transformer-registration-id-card';
import { Fragment } from 'react';
import EditData from './edit-data';
import AccordionRegistrationIdentityCard from './id-card';
import AccordionPerson from './person';
import { RegistationIdCardFormVM } from 'front-office/view-models/registration-id-card';

const RegisterIdCardForm = (): React.ReactElement => {
  const formikContext = useFormikContext<RegistationIdCardFormVM>();

  const onClear = () => {
    formikContext.setFieldValue('identityCard', emptyIdentityCard);
  };

  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData disabled />
      <AccordionRegistrationIdentityCard />
      <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        <PmiButton variant="outlined" color="cdmBrand" onClick={onClear}>
          Ripulisci
        </PmiButton>
      </div>
    </Fragment>
  );
};

RegisterIdCardForm.displayName = 'Register id card form component';

export default RegisterIdCardForm;
